import { observer } from 'mobx-react'
import styled from 'styled-components'
import type { VehicleModuleVersion } from 'models/Vehicles/VehicleModuleVersionModel'
import { GhostButton } from '../Button/Button'
import { SvgIcons } from '../Icon/Icon'
import { Column, Row, Table, Tbody, Td, Th, Thead, Tr } from '../Table/Table'
import { BodyText } from '../Typography/Typography'

const VehicleVersionsInfoContainer = styled(Column)`
`

interface ModuleVersionRowProps {
    moduleVersion: VehicleModuleVersion
}
const ModuleVersionRow = observer(({ moduleVersion }: ModuleVersionRowProps) => 
    <Tr>
        <Td>{ moduleVersion.displayName }</Td>
        <Td>{ moduleVersion.displayVersion }</Td>
        <Td style={{ textAlign: 'right'}}>
            <GhostButton {...{
                text: 'copy',
                startComponent: <SvgIcons.CopySvg />,
                onClick: () => { 
                    void window.navigator.clipboard.writeText(moduleVersion.copyText)
                 }
            }}
        /></Td>
    </Tr>)

interface VehicleVersionsInfoProps {
    versionInfo: Array<VehicleModuleVersion> | undefined
}
export const VehicleVersionsInfo = observer(({ versionInfo } : VehicleVersionsInfoProps) => {
    return (
    <VehicleVersionsInfoContainer>
        <BodyText>Versions Info</BodyText>
        <Table>
            <Thead>
                <Tr>
                    <Th>Module</Th>
                    <Th>Version</Th>
                    <Th>
                        <Row style={{ justifyContent: 'flex-end' }}>
                            copy all
                            <GhostButton {...{
                                text: 'copy all',
                                startComponent: <SvgIcons.CopySvg />,
                                onClick: () => { 
                                    const allVersionInfo = versionInfo?.map(moduleVersion => moduleVersion.copyText).join() ?? ''
                                    void window.navigator.clipboard.writeText(allVersionInfo)
                                }
                            }} />
                        </Row>
                    </Th> 
                </Tr>
            </Thead>
            <Tbody>
                { versionInfo?.map( moduleVersion => <ModuleVersionRow {...{ key: moduleVersion.module, moduleVersion}} />) }
            </Tbody>
        </Table>
    </VehicleVersionsInfoContainer>)
})